<template>
  <div>
    <!-- <v-alert
      border="top"
      color="primary"
      dark
    >
      <h1 class="text-center">Informações sobre membros</h1>
    </v-alert> -->
    <!-- <br>
    <v-row>

    </v-row>
    <br>
    <v-row>
      <v-col cols="4">
        <v-calendar></v-calendar>
      </v-col>
      <v-col cols="4">
        <v-calendar></v-calendar>
      </v-col>
      <v-col cols="4">
        <v-calendar></v-calendar>
      </v-col>
    </v-row>-->

    <v-alert
      color="info"
      border="left"
      elevation="2"
      colored-border
    >
      Aniversariantes do Mês!
    </v-alert>

    <v-row justify="left">
      <v-slide-group
        center-active
        show-arrows
      >
        <v-card
          height="100"
          width="auto"
          padding="0"
          margin="0"
          class="ma-4"
          color="#952175"
          v-for="(item, i) in Birthday" :key="i"
          @click="whatsappLink(item.phone)"
        >
          <v-card-text
            class="d-flex white--text justify-space-between align-center"
          >
            <v-avatar
              size="60"
              color="white"
              style="border: 3px solid #444"
            >
                <span class="text-h5" style="color: #952175; font-weight: bold;"> {{ item.day }}</span>
            </v-avatar>
            <v-card-actions class="d-flexResult white--text text-h5">
              {{ item.name + ' ' + item.lastname }}
            </v-card-actions>
            <div style="font-size:14px;">
              <v-icon color="white">mdi-cake-variant</v-icon>
              <!-- <strong> {{ Birthday.day }}</strong> -->
              <!-- <span>Last 3 weeks</span> -->
            </div>
          </v-card-text>
        </v-card>
      </v-slide-group>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Membros</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                max-width="1000px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="purple accent-4"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Novo Membro
                  </v-btn>
                </template>

                <btn-novo-membro
                  v-on:cancelar="close()"
                  v-on:closeAfterSave="close()"
                  :desserts="membros"
                />
              </v-dialog>
              <v-dialog
                v-model="dialogEditMembro"
                max-width="1000px"
              >
                <editar-membro
                  v-on:cancelar="close()"
                  v-on:closeAfterSave="close()"
                  :desserts="membros"
                  :editarMembro="editMembro"
                />
              </v-dialog>
              <v-dialog
                v-model="dialogDelete"
                max-width="500px"
              >
                <v-card>
                  <v-card-title class="text-h5">Tem certeza que deseja excluir esse membro?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeDelete"
                    >Cancelar</v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="deleteItemConfirm"
                    >OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.ativo`]="{ item }">
            <v-avatar
              v-show="item.ativo === true"
              color="teal"
              size="12"
            >
              <span class="white--text text-h5"></span>
            </v-avatar>
            <v-avatar
              v-show="item.ativo === false"
              color="red"
              size="12"
            >
              <span class="white--text text-h5"></span>
            </v-avatar>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              x-small
              dark
              fab
              color="cyan"
              class="ma-1"
              @click="editItem(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              dark
              fab
              color="error"
              class="ma-1"
              @click="deleteItem(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <!-- <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Reset
            </v-btn>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// export default {
//   name: 'Financas'
// }
import api from './../../../plugins/api'
import BtnNovoMembro from '../Components/Forms/NovoMembro.vue'
import EditarMembro from '../Components/Forms/EditarMembro.vue'
import Cookie from 'js-cookie'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  name: 'Financas',
  components: {
    BtnNovoMembro,
    EditarMembro
  },
  data: () => ({
    dialog: false,
    dialogEditMembro: false,
    dialogDelete: false,
    headers: [
      {
        text: 'Ativo',
        align: 'start',
        sortable: false,
        value: 'ativo'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Sobrenome', value: 'sobrenome' },
      { text: 'Aniversário', value: 'dataNascimento' },
      { text: 'Contato', value: 'celular' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    membros: {},
    desserts: [],
    editedIndex: -1,
    editMembro: false,
    objSession: [],
    idMembroDel: null,
    Birthday: {
      name: '',
      lastname: '',
      day: 0,
      phone: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },

  created () {
    this.getListBirthday()
    this.getMembros()
  },

  methods: {
    editItem (item) {
      this.membros = item // aqui eu envio o objeto do membro para editar no componente filho...

      this.dialogEditMembro = true
    },

    deleteItem (item) {
      this.idMembroDel = item.id
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      api.delete('/membros/' + this.idMembroDel).then((resp) => {
        this.dialogDelete = false
        document.location.reload()
      }).catch(() => {
      })
    },

    close () {
      this.membros = {}
      this.dialog = false
      this.dialogEditMembro = false
      this.getMembros()
    },

    closeDelete () {
      this.dialogDelete = false
      this.getMembros()
    },
    getMembros () {
      // this.objSession = JSON.parse(sessionStorage.getItem('Sessão teste'))
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      let idChurch = Number(decriptToken.id_church)
      api.get('/membros?idChurch=' + idChurch).then((response) => {
        let items = response.data
        items.results.forEach(element => {
          element.dataNascimento = new Date(element.dataNascimento).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
          element.batismoNasAguas = new Date(element.batismoNasAguas).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
          element.dataDeInicio = new Date(element.dataDeInicio).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
          element.frequentaIEQDesde = new Date(element.frequentaIEQDesde).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
        })
        this.desserts = items.results
      })
    },
    getListBirthday () {
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      // console.log('id_church', decriptToken)
      // this.objSession = JSON.parse(sessionStorage.getItem('Sessão teste'))
      api.get('/birthday?idchurch=' + Number(decriptToken.id_church)).then((response) => {
        let resp = response.data.objeto
        this.Birthday = resp
      })
    },
    whatsappLink (value) {
      // console.log('Link: ', value)
      // window.location.href = 'https://wa.me/55' + value
      if (value === null || value === '') {
        return alert('Membro não tem número de telefone!')
      }
      window.open('https://wa.me/55' + value, '_blank')
    }
  }
}
</script>
